import { render, staticRenderFns } from "./LogoAndBid.vue?vue&type=template&id=48c8c82c&scoped=true&"
import script from "./LogoAndBid.vue?vue&type=script&lang=js&"
export * from "./LogoAndBid.vue?vue&type=script&lang=js&"
import style0 from "./LogoAndBid.vue?vue&type=style&index=0&id=48c8c82c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c8c82c",
  null
  
)

export default component.exports